<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-input v-model="queryForm.boutiqueCategory1Name" placeholder="L1 Category" style="width: 200px"></el-input>
      <el-input v-model="queryForm.boutiqueCategory3Name" placeholder="L3 Category or L4 Category" style="width: 200px"></el-input>
      <el-button type="primary" @click="showSearch">搜索</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <div class="action">
      <el-button size="small" type="primary" @click="addCategory">Add</el-button>
      <div class="upload-btn" v-if="vendorId">
        <el-button size="small" type="primary">导入类目</el-button>
        <input @change="changeFile" accept=".csv" type="file" />
      </div>
      <el-button size="small" type="primary" plain v-if="vendorId" @click="downloadTemplate">下载模板</el-button>
    </div>

    <ul class="menus-level-1">
      <li v-for="(item, index) in categoryList" :key="item.categoryId" :class="{active: categoryCurrIndex == index }" @click="switchCategoryL1(index)">{{ item.name }}</li>
    </ul>
    <ul class="menus-level-2" v-if="categoryList && categoryList.length > 0">
      <li v-for="(item, index) in categoryList[categoryCurrIndex].children" :key="item.categoryId">
        <div class="menus-title" @click="clickLevel2(item, index)" :class="{active: !item.fold}"><Icon :type="item.fold ? 'chevron-right' : 'chevron-down'"></Icon>{{ item.name }}</div>
        <div class="menus-level-3" v-if="!item.fold">
          <ul>
            <li v-for="(sub, sindex) in item.children" :key="sub.categoryId" :class="{active: item.subActive === sindex}" @click="clickLevel3(sub, sindex, item)">{{ sub.name }}</li>
          </ul>
        </div>
        <div class="table-container" v-if="!item.fold && item.subActive != null" @click="tempL2index = index">
          <Table
            :columns="columns"
            :data="item.table.data"
          />
          <div class="table-footer" @click="activeItemIndex = index">
            <Page
              :total="item.table.total"
              :page-size-opts="pageSizeOpts"
              :page-size.sync="item.table.pageSize"
              :current="item.table.currentPage"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              show-sizer
              show-total/>
          </div>
        </div>
      </li>
    </ul>

    <el-dialog
      :visible.sync="showEditForm"
      :title="isEdit ? 'Edit Boutique Category':'Add Boutique Category'"
      width="495px"
      append-to-body
      close-on-click-modal>
      <el-form ref="editForm" :model="formItem" :rules="ruleValidate" size="mini">
        <el-form-item prop="firstCategory">
          <el-select style="width: 100%" v-model="formItem.firstCategory" @change="changeL1" placeholder="Select">
            <el-option v-for="item in categoryList" :key="item.categoryId" :value="item.categoryId" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="secondCategory">
          <el-select style="width: 100%" v-model="formItem.secondCategory" filterable @change="changeL2" placeholder="Select">
            <el-option v-for="item in categoryLevel2" :key="item.categoryId" :value="item.categoryId" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="thirdCategory">
          <el-select style="width: 100%" v-model="formItem.thirdCategory" filterable @change="changeL3" placeholder="Select">
            <el-option v-for="item in categoryLevel3" :key="item.categoryId" :value="item.categoryId" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 100%" v-model="formItem.l4CategoryId" filterable clearable @change="changeL4" placeholder="Select">
            <el-option v-for="item in categoryLevel4" :key="item.categoryId" :value="item.categoryId" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="boutiqueCategory1Name">
          <el-input v-model="formItem.boutiqueCategory1Name" maxlength="100" placeholder="L1 Category"></el-input>
        </el-form-item>
        <el-form-item prop="boutiqueCategory3Name">
          <el-input v-model="formItem.boutiqueCategory3Name" maxlength="100" placeholder="L3 Category"></el-input>
        </el-form-item>
        <el-form-item prop="boutiqueFourCategory">
          <el-input v-model="formItem.boutiqueFourCategory" maxlength="100" placeholder="L4 Category"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input style="width: 370px" v-model="inputStr" @keypress.enter.native="parseCategory" maxlength="200" placeholder="粘贴信息，自动拆分L1 Category、L3 Category、L4 Category"></el-input>
          <el-button type="primary" @click="parseCategory">智能识别</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">Cancel</el-button>
        <el-button type="primary" @click="handleSubmit('editForm')">OK</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showSearchDialog"
      title="搜索"
      width="800px"
      append-to-body
      close-on-click-modal>
      <div class="query-form">
        <el-input v-model="queryForm.boutiqueCategory1Name" placeholder="L1 Category" style="width: 150px"></el-input>
        <el-input v-model="queryForm.boutiqueCategory3Name" placeholder="L3 Category or L4 Category" style="width: 150px"></el-input>
        <el-button style="margin-left: 20px" type="primary" @click="search">搜索</el-button>
        <el-button @click="resetAndSearch">重置</el-button>
      </div>
      <el-table :data="tableData" v-loading="searchLoading">
        <el-table-column prop="boutiqueCategory1Name" label="L1">
          <template slot-scope="scope">
            <div v-html="scope.row.boutiqueCategory1Name"></div>
          </template>
        </el-table-column>
        <el-table-column prop="boutiqueCategory3Name" label="L3">
          <template slot-scope="scope">
            <div v-html="scope.row.boutiqueCategory3Name"></div>
          </template>
        </el-table-column>
        <el-table-column prop="boutiqueFourCategory" label="L4">
          <template slot-scope="scope">
            <div v-html="scope.row.boutiqueFourCategory"></div>
            {{scope.row.imFourCategory ? "（" + scope.row.imFourCategory + "）" : ""}}
          </template>
        </el-table-column>
        <el-table-column label="">
          <template slot-scope="scope">
            <i class="el-icon-edit" @click="clickEditForm(scope.row)"></i>
            <i style="margin-left: 10px" class="el-icon-delete" @click="delCategoryMappingPass(scope.row.categoryMapId)"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.currentPage"
        :page-size="queryForm.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-dialog>

    <el-dialog
      :visible.sync="showImportResultDialog"
      width="400px"
      append-to-body
      close-on-click-modal>
      <h2 class="red" slot="title">导入失败</h2>
      <p v-if="errorMsg">{{ errorMsg }}</p>
      <el-button v-if="errorUrl" type="primary" plain @click="downloadResult">下载导入结果</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import Client from "@/utils/client.js";
  import { downloadUrlFile } from '@/utils/functions';
  import {
    getCategory,
    getCategoryMappingPassList,
    addCategoryMappingPass,
    delCategoryMappingPass,
    editCategoryMappingBlock,
    fileUpload,
    importCategory,
    getFourCategoryList
  } from '../../api/mapping';

  export default {
    props: {
      vendorId: Number,
      vendorSystemId: Number
    },
    data() {
      return {
        categoryList: [],
        categoryCurrIndex: 0,
        categoryLevel2: [],
        categoryLevel3: [],
        categoryLevel4: [],
        activeItemIndex: null,
        tempL2index: null,
        status: 0,
        columns: [
          {
            title: "L1",
            key: 'boutiqueCategory1Name',
            render: (h, params) => {
              return h('div', {
                domProps: {
                  innerHTML: params.row.boutiqueCategory1Name.split(" ").join("&nbsp;"),
                }
              });
            }
          },
          {
            title: "L3",
            key: 'boutiqueCategory3Name',
            render: (h, params) => {
              return h('div', {
                domProps: {
                  innerHTML: params.row.boutiqueCategory3Name.split(" ").join("&nbsp;"),
                }
              });
            }
          },
           {
            title: "L4",
            key: 'boutiqueFourCategory',
            render: (h, params) => {
              return h('div', {
                domProps: {
                  innerHTML: params.row.boutiqueFourCategory.split(" ").join("&nbsp;") + "（" + params.row.imFourCategory + "）",
                }
              });
            }
          },
          {
            width: 180,
            align: 'right',
            renderHeader: (h, params) => {
              return h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      setTimeout(() => {
                        this.isEdit = false;

                        this.formItem.categoryMapId = null;

                        const item = this.categoryList[this.categoryCurrIndex];
                        const item2 = item.children[this.tempL2index];
                        const item3 = item2.children[item2.subActive];
                        this.formItem.firstCategory = item.categoryId;
                        this.changeL1();
                        this.formItem.secondCategory = item2.categoryId;
                        this.changeL2();
                        this.formItem.thirdCategory = item3.categoryId;
                        this.changeL3();

                        this.formItem.boutiqueCategory1Name = '';
                        this.formItem.boutiqueCategory3Name = '';
                        this.formItem.boutiqueFourCategory = '';

                        this.inputStr = '';

                        this.showEditForm = true;
                      }, 100);
                    }
                  }
                },
                'Add'
              )
            },
            render: (h, params) => {
              return h("div", [
                h(
                  "Icon",
                  {
                    props: {
                      type: "edit",
                      size: 20
                    },
                    on: {
                      click: () => {
                        this.isEdit = true;

                        this.formItem.categoryMapId = params.row.categoryMapId;
                        // 根据三级ID查找一二级ID
                        this.categoryList.filter((item) => {
                          item.children.forEach((item2) => {
                            item2.children.forEach((item3) => {
                              if (params.row.categoryId === item3.categoryId) {
                                this.formItem.firstCategory = item.categoryId;
                                this.changeL1();
                                this.formItem.secondCategory = item2.categoryId;
                                this.changeL2();
                                this.formItem.thirdCategory = item3.categoryId;
                                this.changeL3();
                              }
                            });
                          });
                        });

                        this.formItem.l4CategoryId = params.row.l4CategoryId || "";
                        this.formItem.boutiqueCategory1Name = params.row.boutiqueCategory1Name;
                        this.formItem.boutiqueCategory3Name = params.row.boutiqueCategory3Name;
                        this.formItem.boutiqueFourCategory = params.row.boutiqueFourCategory;

                        this.inputStr = '';

                        this.showEditForm = true;
                      }
                    },
                    style: {
                      padding: '0 10px',
                      cursor: 'pointer'
                    }
                  }
                ),
                h(
                  "Icon",
                  {
                    props: {
                      type: "trash-a",
                      size: 24
                    },
                    on: {
                      click: () => {
                        this.delCategoryMappingPass(params.row.categoryMapId);
                      }
                    },
                    style: {
                      padding: '0 10px',
                      cursor: 'pointer'
                    }
                  }
                )
              ]);
            }
          }
        ],
        pageSizeOpts: [15, 20, 30, 50],
        showEditForm: false,
        isEdit: false,
        formItem: {
          categoryMapId: null,
          categoryId: null,
          firstCategory: null,
          secondCategory: null,
          thirdCategory: null,
          l4CategoryId: null,
          boutiqueCategory1Name: '',
          boutiqueFourCategory: '',
          boutiqueCategory3Name: '',
        },
        ruleValidate: {
          firstCategory: [
            { required: true, message: 'Please select level 1 category', trigger: 'blur' }
          ],
          secondCategory: [
            { required: true, message: 'Please select level 2 category', trigger: 'blur' }
          ],
          thirdCategory: [
            { required: true, message: 'Please select level 3 category', trigger: 'blur' }
          ],
          l4CategoryId: [
            { required: true, message: 'Please select level 4 category', trigger: 'blur' }
          ],
          boutiqueCategory1Name: [
            { required: true, message: 'Please enter l1 category', trigger: 'blur' },
          ],
        },
        inputStr: '',
        queryForm: {
          boutiqueCategory1Name: '',
          boutiqueCategory3Name: '',
          currentPage: 1,
          pageSize: 10,
        },
        showSearchDialog: false,
        tableData: [],
        total: 0,
        searchLoading: false,
        fullscreenLoading: false,
        showImportResultDialog: false,
        errorMsg: '',
        errorUrl: '',
        fourthCategoryList: []
      };
    },
    methods: {
      trigger() {
        this.categoryList.forEach(l1 => {
          l1.children.forEach(l2 => {
            l2.fold = true;
            l2.subActive = null;
            l2.table = {
              currentPage: 1,
              pageSize: 15,
              total: 0,
              data: []
            };
          });
        });
      },
      init() {
        this.$store.commit("setPageLoading", true);
        getFourCategoryList().then(res => {
          if (res.data && res.data.data) {
            const categoryList = res.data.data;
            categoryList.forEach(l1 => {
              l1.children.forEach(l2 => {
                l2.fold = true;
                l2.subActive = null;
                l2.table = {
                  currentPage: 1,
                  pageSize: 15,
                  total: 0,
                  data: []
                };
              });
            });
            this.categoryList = categoryList;
            this.initCategoryLevel3();
          }
          this.$store.commit("setPageLoading", false);
        }).catch(() => {
          this.$store.commit("setPageLoading", false);
        })
      },
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.submit();
          }
        })
      },
      submit() {
        if (this.formItem.thirdCategory && !this.formItem.l4CategoryId && (!this.formItem.boutiqueCategory3Name || this.formItem.boutiqueFourCategory)) {
          this.$message.error("L3 Category 必填，L4 Category不可以填");
          return;
        }
        if (this.formItem.l4CategoryId && (this.formItem.boutiqueCategory3Name || !this.formItem.boutiqueFourCategory)) {
          this.$message.error("L3 Category 不可以填，L4 Category必填");
          return;
        }
        let request = addCategoryMappingPass;
        if (this.formItem.categoryMapId) {
          request = editCategoryMappingBlock;
        }
        request({
          categoryMapId: this.formItem.categoryMapId,
          categoryId: this.formItem.categoryId,
          l4CategoryId: this.formItem.l4CategoryId,
          vendorId: this.vendorId,
          vendorSystemId: this.vendorSystemId,
          boutiqueCategory1Name: this.formItem.boutiqueCategory1Name,
          boutiqueCategory3Name: this.formItem.boutiqueCategory3Name,
          boutiqueFourCategory: this.formItem.boutiqueFourCategory,
        }).then(res => {
          if (res.data && res.data.code == '200') {
            this.showEditForm = false;
            this.$message.success("save success");
            if (this.isSearch) {
              this.isSearch = false;
              this.search();
              return;
            }
            if (this.tempL2index != null) {
              const item = this.categoryList[this.categoryCurrIndex].children[this.tempL2index];
              this.getCategoryMappingPassList(item, item.children[item.subActive].categoryId, item.table.currentPage, item.table.pageSize);
            }
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(() => {
          this.$message.error('系统异常');
        })
      },
      pageChange(index) {
        const item = this.categoryList[this.categoryCurrIndex].children[this.activeItemIndex];
        item.table.currentPage = index;
        this.getCategoryMappingPassList(item, item.children[item.subActive].categoryId, item.table.currentPage, item.table.pageSize)
      },
      pageSizeChange(size) {
        const item = this.categoryList[this.categoryCurrIndex].children[this.activeItemIndex];
        item.table.pageSize = size;
        this.getCategoryMappingPassList(item, item.children[item.subActive].categoryId, item.table.currentPage, item.table.pageSize)
      },
      initCategoryLevel3() {
        this.$nextTick(() => {
          const l3Containers = document.querySelectorAll('.menus-level-3');
          l3Containers.forEach(l3c => {
            const ul = l3c.children[0];
            const allLi = ul.children;
            let width = 40;
            for (let i=0; i<allLi.length; i++) {
              width += allLi[i].clientWidth;
            }
            ul.style.width = width + 'px';
          });
        });
      },
      switchCategoryL1(index) {
        this.categoryCurrIndex = index;
        this.initCategoryLevel3();
      },
      clickLevel2(item, index) {
        item.fold = !item.fold;
        if (!item.fold) {
          this.initCategoryLevel3();
        }
      },
      clickLevel3(sub, index, item) {
        item.subActive = index;
        item.table.currentPage = 1;
        item.table.pageSize = 15;
        item.table.data = [];
        item.table.total = 0;
        this.getCategoryMappingPassList(item, sub.categoryId, item.table.currentPage, item.table.pageSize);
      },
      getCategoryMappingPassList(item, categoryId, currentPage, pageSize) {
        this.$store.commit("setPageLoading", true);
        getCategoryMappingPassList({
          vendorId: this.vendorId,
          vendorSystemId: this.vendorSystemId,
          categoryId,
          currentPage,
          pageSize
        }).then(res => {
          this.$store.commit("setPageLoading", false);
          if (res.data) {
            item.table.data = res.data.data.list || [];
            item.table.total = res.data.data.total;
          }
        }).catch(() => {
          this.$store.commit("setPageLoading", false);
        });
      },
      addCategory() {
        this.isEdit = false;
        this.formItem.categoryId = null;
        this.formItem.categoryMapId = null;
        this.formItem.firstCategory = null;
        this.formItem.secondCategory = null;
        this.formItem.thirdCategory = null;
        this.formItem.l4CategoryId = null;
        this.formItem.boutiqueCategory1Name = '';
        this.formItem.boutiqueFourCategory = '';
        this.formItem.boutiqueCategory3Name = '';
        this.tempL2index = null;

        this.showEditForm = true;
      },
      changeL1() {
        if (this.formItem.firstCategory) {
          const item = this.categoryList.filter((item) => {
            return item.categoryId === this.formItem.firstCategory;
          });
          this.formItem.secondCategory = null;
          this.categoryLevel2 = item[0].children;
          this.formItem.thirdCategory = '';
          this.formItem.l4CategoryId = '';
          this.categoryLevel3 = [];
          this.categoryLevel4 = [];
        } else {
          this.formItem.secondCategory = null;
          this.formItem.thirdCategory = null;
          this.formItem.l4CategoryId = null;
          this.categoryLevel2 = [];
          this.categoryLevel3 = [];
          this.categoryLevel4 = [];
        }
      },
      changeL2() {
        if (this.formItem.secondCategory) {
          const item = this.categoryLevel2.filter((item) => {
            return item.categoryId === this.formItem.secondCategory;
          });
          this.formItem.thirdCategory = '';
          this.formItem.l4CategoryId = '';
          this.categoryLevel3 = item[0].children;
          this.categoryLevel4 = [];
        } else {
          this.formItem.thirdCategory = '';
          this.formItem.l4CategoryId = '';
          this.categoryLevel3 = [];
          this.categoryLevel4 = [];
        }
      },
      changeL3() {
        if (this.formItem.thirdCategory) {
          const item = this.categoryLevel3.filter((item) => {
            return item.categoryId === this.formItem.thirdCategory;
          });
          this.formItem.categoryId = item[0].categoryId;
          this.formItem.l4CategoryId = '';
          this.categoryLevel4 = item[0].children;
        } else {
           this.formItem.categoryId = '';
          this.formItem.l4CategoryId = '';
          this.categoryLevel4 = [];
        }
      },
      changeL4() {

      },
      delCategoryMappingPass(categoryMapId) {
        this.$confirm('Are you sure to delete ?', 'Message', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          delCategoryMappingPass({
            categoryMapId,
          }).then(res => {
            if (res.data && res.data.code == '200') {
              this.$message.success('delete success');
              if (this.tempL2index != null) {
                const item = this.categoryList[this.categoryCurrIndex].children[this.tempL2index];
                this.getCategoryMappingPassList(item, item.children[item.subActive].categoryId, item.table.currentPage, item.table.pageSize);
              }
            } else {
              this.$message(res.data.message);
            }
          })
        }).catch(() => {

        });
      },
      parseCategory() {
        let arr = [];
        if (this.inputStr.indexOf('\n') > -1) {
          arr = this.inputStr.split('\n');
        } else if (this.inputStr.indexOf('\r') > -1) {
          arr = this.inputStr.split('\r');
        } else if (this.inputStr.indexOf('\t') > -1) {
          arr = this.inputStr.split('\t');
        } else if (this.inputStr.indexOf(' ') > -1) {
          arr = this.inputStr.split(' ');
        } else if (this.inputStr.indexOf(',') > -1) {
          arr = this.inputStr.split(',');
        } else if (this.inputStr.indexOf('，') > -1) {
          arr = this.inputStr.split('，');
        } else if (this.inputStr.indexOf('>') > -1) {
          arr = this.inputStr.split('>');
        }
        const valueArr = arr.filter(item => item);
        if (valueArr.length === 2) {
          this.formItem.boutiqueCategory1Name = valueArr[0];
          if (this.formItem.l4CategoryId) {
            this.formItem.boutiqueCategory3Name = '';
            this.formItem.boutiqueFourCategory = valueArr[1];
          } else {
            this.formItem.boutiqueCategory3Name = valueArr[1];
            this.formItem.boutiqueFourCategory = '';
          }

        } else {
          for (let i = 1; i < 4; i++) {
            if (i == 1) {
              this.formItem[`boutiqueCategory${i}Name`] = valueArr[i - 1];
            } else {
              this.formItem[`boutiqueCategory${ i + 1 }Name`] = valueArr[i - 1];
            }
          }
        }
        this.inputStr = '';
        this.$refs.editForm.clearValidate();
      },
      showSearch() {
        this.showSearchDialog = true;
        this.queryForm.currentPage = 1;
        this.getTableData();
      },
      search() {
        this.queryForm.currentPage = 1;
        this.getTableData();
      },
      getTableData() {
        this.searchLoading = true;
        getCategoryMappingPassList({
          vendorId: this.vendorId,
          vendorSystemId: this.vendorSystemId,
          boutiqueCategory1Name: this.queryForm.boutiqueCategory1Name,
          boutiqueCategory3Name: this.queryForm.boutiqueCategory3Name,
          currentPage: this.queryForm.currentPage,
          pageSize: this.queryForm.pageSize,
        }).then(res => {
          console.log(res)
          if (res.data && res.data.data) {
            this.tableData = res.data.data.list.map(item => {
              item.boutiqueCategory1Name = item.boutiqueCategory1Name ? item.boutiqueCategory1Name.split(" ").join("&nbsp;") : "";
              item.boutiqueCategory3Name = item.boutiqueCategory3Name ? item.boutiqueCategory3Name.split(" ").join("&nbsp;") : "";
              item.boutiqueFourCategory = item.boutiqueFourCategory ? item.boutiqueFourCategory.split(" ").join("&nbsp;") : "";
              return item;
            });
            this.total = res.data.data.total;
          }
          this.searchLoading = false;
        }).catch(() => {
          this.searchLoading = false;
        });
      },
      resetAndSearch() {
        this.reset();
        this.getTableData();
      },
      reset() {
        this.queryForm.boutiqueCategory1Name = '';
        this.queryForm.boutiqueCategory3Name = '';
        this.queryForm.currentPage = 1;
      },
      handleSizeChange(pageSize) {
        this.queryForm.pageSize = pageSize;
        this.getTableData();
      },
      handleCurrentChange(currentPage) {
        this.queryForm.currentPage = currentPage;
        this.getTableData();
      },
      clickEditForm(row) {
        this.isEdit = true;
        this.formItem.categoryMapId = row.categoryMapId;
        // 根据三级ID查找一二级ID
        this.categoryList.filter((item) => {
          item.children.forEach((item2) => {
            item2.children.forEach((item3) => {
              if (row.categoryId === item3.categoryId) {
                this.formItem.firstCategory = item.categoryId;
                this.changeL1();
                this.formItem.secondCategory = item2.categoryId;
                this.changeL2();
                this.formItem.thirdCategory = item3.categoryId;
                this.changeL3();
              }
            });
          });
        });

        this.formItem.l4CategoryId = row.l4CategoryId || "";
        this.formItem.boutiqueCategory1Name = row.boutiqueCategory1Name;
        this.formItem.boutiqueCategory3Name = row.boutiqueCategory3Name;
        this.formItem.boutiqueFourCategory = row.boutiqueFourCategory;

        this.inputStr = '';

        this.showEditForm = true;

        this.isSearch = true;
      },
      downloadTemplate() {
        downloadUrlFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/excel-templates/import-category-mapping-template.csv');
      },
      async changeFile(e) {
        if (e && e.target && e.target.files && e.target.files[0]) {
          this.fullscreenLoading = true;
          const file = e.target.files[0];
          const confRes = await fileUpload();
          console.log(confRes);
          const OSSClient = Client(confRes.data.data);
          const random_name = 'tmp/' + this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
          const ossRes = await OSSClient.put(random_name, file);
          const fileUrl = ossRes.res.requestUrls[0];
          const res = await importCategory({ url: fileUrl, vendorId: this.vendorId });
          if (res.data && res.data.success) {
            this.$message.success('导入成功');
          } else if (res.data && res.data.code == '1037') {
            this.errorMsg = '';
            this.errorUrl = res.data.data.url;
            this.showImportResultDialog = true;
          } else if (res.data) {
            this.errorUrl = '';
            this.errorMsg = res.data.message;
            this.showImportResultDialog = true;
          }
          this.fullscreenLoading = false;
        }
        e.target.value = '';
      },
      downloadResult() {
        downloadUrlFile(this.errorUrl);
      },
      random_string(len) {
        len = len || 32;
        let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
        for (let i = 0; i < len; i++) {
          pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
      },
    },
    mounted() {
      this.init();
    }
  };
</script>

<style lang="less" scoped>
.action {
  text-align: right;
}
  .table-footer{
    padding-top: 10px;
    text-align: right;
  }
  .menus-level-1{
    position: relative;
    height: 50px;
    margin: 10px 0;
    line-height: 48px;
    list-style: none;

    &:after{
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      display: block;
      width: 100%;
      height: 1px;
      background-color: #dddee1;
      clear: both;
    }

    li{
      position: relative;
      float: left;
      padding: 0 20px;
      font-size: 16px;
      z-index: 2;
      cursor: pointer;

      &.active,
      &:hover{
        color: #2d8cf0;
        border-bottom: 2px solid #2d8cf0;
      }
    }
  }
  .menus-level-2{
    list-style: none;
    border-top: 1px solid #dcdee2;

    & > li{
      border-right: 1px solid #dcdee2;
      border-left: 1px solid #dcdee2;
      border-bottom: 1px solid #dcdee2;
      overflow: hidden;
    }
    .menus-title{
      padding: 0 15px;
      line-height: 40px;
      background-color: #f7f7f7;
      cursor: pointer;

      .ivu-icon{
        margin-right: 10px;
        font-size: 12px;
      }

      &.active{
        color: #2d8cf0;
      }
    }
    .table-container{
      margin: 15px;
    }
  }
  .menus-level-3{
    margin: 15px;
    padding-bottom: 0px;
    overflow: auto;

    ul {
      width: 4000px;
      height: 40px;
      line-height: 40px;
      list-style: none;
      overflow: hidden;

      &:after{
        content: '';
        display: block;
        clear: both;
      }

      li {
        float: left;
        padding: 0 15px;
        cursor: pointer;

        &.active,
        &:hover{
          color: #2d8cf0;
        }
      }
    }

  }
.upload-btn {
  position: relative;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 1;
  }
}
.red {
  color: red;
}
.mt20 {
  margin-top: 20px;
}
</style>
